import api from './api';
import router from '../../router';

//Path Regex to check if socket listener should be used
const pathRegex = /^\/calendar/;

const state = {
	days: [],
	loading: true,
	loadingDutyActivities: false,
	error: false,
	message: '',
	showDeleted: false,
};

const getters = {};

const mutations = {
	startLoading(state) {
		state.loading = true;
	},
	stopLoading(state) {
		state.loading = false;
		state.error = false;
	},
	startLoadingDutyActivities(state) {
		state.loadingDutyActivities = true;
	},
	stopLoadingDutyActivities(state) {
		state.loadingDutyActivities = false;
		state.error = false;
	},
	setDuties(state, { duties, days, showDeleted }) {
		// Set days
		state.days = days.sort(function (a, b) {
			return -b.date.localeCompare(a.date);
		});
		state.showDeleted = showDeleted;

		// Create a lookup table from day.id to index of day in state.days
		const dayMap = {};
		state.days.forEach((day, index) => {
			dayMap[day.id] = index;
		});

		// Initialize duties array in all days
		state.days.forEach((day) => {
			day.duties = [];
		});

		// Attach duties to their days
		duties
			.filter((duty) => duty.provider !== 'core')
			.forEach((duty) => {
				state.days[dayMap[duty.day]]?.duties.push(duty);
			});

		// Sort duties by name
		state.days.forEach((day) => {
			day.duties = day.duties.sort(function (a, b) {
				return -b.name.localeCompare(a.name);
			});
		});
	},
	setError(state, { message }) {
		state.error = true;
		state.message = message;
	},
};

const actions = {
	async loadDays({ state, commit, rootGetters, dispatch }, showDeleted) {
		commit('startLoading');

		try {
			const days = (await api.loadDays(showDeleted)).data;
			dispatch('loadDuties', days, showDeleted);
		} catch (err) {
			commit('setError', { message: err.response.data.message });
			commit('stopLoading');
		}
	},

	async loadDuties({ state, commit, rootGetters }, days, showDeleted) {
		try {
			const duties = (await api.loadDuties()).data;
			commit('setDuties', { duties, days, showDeleted });
			commit('stopLoading');
		} catch (err) {
			commit('setError', { message: err.response.data.message });
			commit('stopLoading');
		}
	},

	async loadDutyActivities({ state, commit, rootGetters }, dutyId) {
		commit('startLoadingDutyActivities');

		try {
			const dutyActivities = (await api.loadDutyActivities(dutyId)).data;
			commit('stopLoadingDutyActivities');
			return dutyActivities;
		} catch (err) {
			commit('setError', { message: err.response.data.message });
			commit('stopLoadingDutyActivities');
		}
	},

	socket_created_Day({ dispatch, commit }, payload) {
		if (!pathRegex.test(router.currentRoute._value.path)) {
			return;
		}

		dispatch('loadDays', state.showDeleted);
	},

	socket_updated_Day({ dispatch, commit }, payload) {
		if (!pathRegex.test(router.currentRoute._value.path)) {
			return;
		}

		dispatch('loadDays', state.showDeleted);
	},

	socket_deleted_Day({ dispatch, commit }, payload) {
		if (!pathRegex.test(router.currentRoute._value.path)) {
			return;
		}

		dispatch('loadDays', state.showDeleted);
	},

	socket_deleted_Duty({ dispatch, commit }, payload) {
		if (!pathRegex.test(router.currentRoute._value.path)) {
			return;
		}

		dispatch('loadDuties');
	},

	socket_updated_Duty({ dispatch, commit }, payload) {
		if (!pathRegex.test(router.currentRoute._value.path)) {
			return;
		}

		// dispatch('loadDuties');
	},

	// socket_deletedDuty({ dispatch, commit }, [ids]) {
	// 	// dispatch('loadDuties');
	// },
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
